import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function Person(props) {
  return (
    <SvgIcon {...props}>
      <path d="M14.914 1.147l-9.62 4.352c-.179.08-.294.259-.294.455v16.79h1.95V6.888l8.274-3.743v19.597h4.529V5.973c0-.127-.049-.25-.137-.343L15.483 1.26c-.146-.155-.375-.2-.57-.112z" />
      <path d="M8.256 10.468L13.346 8.891 13.346 6.095 8.256 8.461 8.256 10.468M8.256 14.34L13.346 13.756 13.346 11.113 8.256 12.476 8.256 14.34M8.256 18.211L13.346 18.211 13.346 15.845 8.256 16.275 8.256 18.211M8.256 22.728L13.346 22.728 13.346 20.433 8.256 20.433z" />
    </SvgIcon>
  );
}
